// extracted by mini-css-extract-plugin
export var container = "_2p-0";
export var icon = "_2p-1";